module.exports = [{"label":"300*250","size":[300,250]},{"label":"320*50","size":[320,50]}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/size.json
// module id = Gk6n
// module chunks = 1